import * as Yup from 'yup'
import {useFormik} from 'formik'
import { Link, useNavigate } from 'react-router-dom';
import { FooterLogin, SideLogin } from './Login';


const validarDatos = Yup.object().shape({
    email: Yup.string()
      .required("Campo Requerido")
      .email("Correo Electronico Invalido")
      .max(100, "Máximo 100 carácter"),
    usuario: Yup.string()
        .required('Campo obligatorio'),
})

const valorInicial = {
    email: '',
    usuario: ''
}
export default function ResetPassword(){
    const navigate = useNavigate();
    const onSubmit = async (values) => {
        // enviar datos
        console.log(values);
        navigate("/new-password");
        await new Promise((resolve) => setTimeout(resolve, 1000));
    };

    const {
        values,
        errors,
        touched,
        isSubmitting,
        handleBlur,
        handleChange,
        handleSubmit,
    } = useFormik({
        initialValues: valorInicial,
        validationSchema: validarDatos,
        onSubmit,
    });
    return(
        <>
        <div className="d-flex flex-column flex-root">
			<div className="d-flex flex-column flex-lg-row flex-column-fluid">
				<div className="d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1">
					<div className="d-flex flex-center flex-column flex-lg-row-fluid">
						<div className="w-lg-500px p-10">
							<form className="form w-100" onSubmit={handleSubmit}>
								<div className="text-center mb-10">
									<h1 className="text-dark fw-bolder mb-3">Forgot Password ?</h1>
									<div className="text-gray-500 fw-semibold fs-6">Enter your email to reset your password.</div>
								</div>
                                <div className="fv-row mb-8">
                                    <input
                                        className={"form-control bg-transparent " + (errors.usuario && touched.usuario ? "border-danger" : "")}
                                        name='usuario'
                                        placeholder='Usuario'
                                        type='text'
                                        value={values.usuario}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                    />
                                    {errors.usuario && touched.usuario && <p className="text-danger mt-2">{errors.usuario}</p>}
								</div>
								<div className="fv-row mb-8">
                                    <input
                                        className={"form-control bg-transparent " + (errors.email && touched.email ? "border-danger" : "")}
                                        name='email'
                                        placeholder='Email'
                                        type='email'
                                        value={values.email}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                    />
                                    {errors.email && touched.email && <p className="text-danger mt-2">{errors.email}</p>}
								</div>
								<div className="d-flex flex-wrap justify-content-center pb-lg-0">
									<button type="submit" id="kt_password_reset_submit" disabled={isSubmitting} className="btn btn-primary me-4">
										<span className="indicator-label">Enviar</span>
									</button>
									<Link to={'/'} className="btn btn-light">Cancelar</Link>
								</div>
							</form>
						</div>
					</div>
					<FooterLogin/>
				</div>
				<SideLogin/>
			</div>
		</div>
        </>
    );
}
